import { Component, OnInit, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { Display, FontSizeRescalerService } from '@app/shared/services/font-rescaler.service';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { DisplayComponent } from '@app/shared/components/display/display.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-randomprize-reward-modal',
  templateUrl: './randomprize-reward.component.html',
  styleUrls: ['./randomprize-reward.component.scss'],
  standalone: true,
  imports: [DisplayComponent, ButtonComponent, SharedModule],
})
export class RandomPrizeRewardModalComponent implements OnInit {
  componentDestroy: () => Observable<unknown>;

  protected readonly randomprizeRewardModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private readonly eventManager = inject(EventManager);
  public readonly logger = inject(LoggerService);
  private readonly translateService = inject(TranslateService);
  private readonly fontSizeRescalerService = inject(FontSizeRescalerService);
  private readonly eventsRepo = inject(EventsRepository);

  lang = signal<string>('');
  randomprize = signal<LimitedTimeEvent | null>(null);

  ngOnInit(): void {
    this.lang.set(this.translateService.currentLang);

    const evt = this.eventsRepo.getEventById(this.randomprizeRewardModalData.properties.eventId);

    this.randomprize.set(evt);
  }

  setFontSize(): string {
    return this.fontSizeRescalerService.setFontSize(Display.LTEDisplay, this.randomprizeRewardModalData.reward.credits);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.randomprizeRewardModalData.id, ModalType.Persisted, this.randomprizeRewardModalData)
    );
  }
}
